import React from 'react'
import MethodologyHero from '@/components/methodology/MethodologyHero'
import SuccessFormula from '@/components/methodology/SuccessFormula'
import WhatToExpect from '@/components/methodology/WhatToExpect'
import OurFeatures from '@/components/methodology/OurFeatures'
import CourseMeetings from '@/components/methodology/CourseMeetings'
import InfoQwasar from '@/components/methodology/InfoQwasar'
import ScrollAnimation from '@/components/shared/ScrollAnimation'
import Layout from '@/components/shared/Layout'
import Head from 'next/head'
import { useTranslation } from 'next-i18next'
import PeerstackImage from '../../public/images/Peerstack 1200x630.jpeg'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import ScrollToTopButton from '@/components/shared/ScrollToTopButton'
import WhatsappButton from '@/components/shared/WhatsappButton'

export async function getServerSideProps({ locale }) {
    return {
        props: {
            ...(await serverSideTranslations(locale || "az")),
        },
    };
}

const MethodologyPage = () => {
    const { t } = useTranslation()

    return (
        <Layout>
            <Head>
                <meta charSet="UTF-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <title>{t("meta-title")}</title>
                <meta name="keywords" content="peerstack tech" />
                <meta name="description" content={t("meta-description")} />
                <meta name="image" content={PeerstackImage.src} />
                <link rel="canonical" href="https://peerstack.tech" />
                <meta property="og:site_name" content="peerstack.tech" />
                <meta property="og:title" content={t("meta-title")} />
                <meta property="og:url" content="{{page_link}}" />
                <meta property="og:description" content={t("meta-description")} />
                <meta property="og:type" content="website" />
                <meta property="og:image" content={PeerstackImage.src} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={t("meta-title")} />
                <meta name="twitter:url" content="{{page_link}}" />
                <meta name="twitter:description" content={t("meta-description")} />
                <meta name="twitter:image" content={PeerstackImage.src} />
            </Head>
            <ScrollAnimation delay={100}>
                <MethodologyHero />
            </ScrollAnimation>
            <ScrollAnimation delay={100}>
                <SuccessFormula />
            </ScrollAnimation>
            <ScrollAnimation delay={100}>
                <WhatToExpect />
            </ScrollAnimation>
            <ScrollAnimation delay={100}>
                <OurFeatures />
            </ScrollAnimation>
            <ScrollAnimation delay={100}>
                <CourseMeetings />
            </ScrollAnimation>
            <ScrollAnimation delay={100}>
                <InfoQwasar />
            </ScrollAnimation>
            <ScrollToTopButton />
            <WhatsappButton />
            </Layout>
    )
}

export default MethodologyPage